import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, API } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { ArrowLeft, Trash2 } from "lucide-react";
import FolderUploader from "../components/FolderUploader";

function MediaTile({ item, canDelete, onDelete }) {
  const src = `${API}/media/file/${item.id}`;
  return (
    <div className="break-inside-avoid relative border border-neutral-900 group" data-testid={`media-${item.id}`}>
      {item.kind === "video"
        ? <video src={src} controls preload="metadata" className="w-full bg-black"/>
        : <img src={src} alt="" loading="lazy" className="w-full"/>}
      <div className="flex items-center justify-between px-2 py-1 bg-black">
        <span className="font-mono text-[10px] tracking-widest text-neutral-500">{item.uploader_name.toUpperCase()}</span>
        {canDelete && <button onClick={()=>onDelete(item.id)} className="text-alert p-2 -m-1" data-testid={`media-delete-${item.id}`} aria-label="Elimina"><Trash2 className="w-4 h-4"/></button>}
      </div>
    </div>
  );
}

function MediaGrid({ items, user, onDelete }) {
  if (items.length === 0) {
    return <div className="border border-neutral-800 p-12 text-center label-mono text-neutral-500">// ANCORA NESSUN FILE. SII IL PRIMO.</div>;
  }
  return (
    <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-3 space-y-3">
      {items.map(it => (
        <MediaTile key={it.id} item={it} onDelete={onDelete}
          canDelete={user && (user.role === "admin" || user.id === it.uploader_id)}/>
      ))}
    </div>
  );
}

export default function FolderView() {
  const { id } = useParams();
  const { user } = useAuth();
  const [data, setData] = useState(null);

  const load = useCallback(() => api.get(`/media/folders/${id}`).then(r=>setData(r.data)).catch(()=>setData(false)), [id]);
  useEffect(() => { load(); }, [load]);

  const remove = async (itemId) => {
    if (!window.confirm("Eliminare il file?")) return;
    try { await api.delete(`/media/items/${itemId}`); toast.success("File eliminato"); }
    catch (e) { toast.error("Errore eliminazione"); }
    load();
  };

  if (data === false) return <div className="p-16 text-center label-mono">CARTELLA NON TROVATA</div>;
  if (!data) return <div className="p-16 text-center text-neutral-500 font-mono">LOADING...</div>;

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16">
      <Link to="/gallery" className="label-mono flex items-center gap-2 hover:text-neon mb-6" data-testid="folder-back"><ArrowLeft className="w-3 h-3"/>CARTELLE</Link>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
        <h1 className="font-display text-4xl lg:text-6xl" data-testid="folder-title">{data.folder.name}</h1>
        <FolderUploader folderId={id} user={user} onUploaded={load}/>
      </div>
      <MediaGrid items={data.items} user={user} onDelete={remove}/>
    </div>
  );
}
